// extracted by mini-css-extract-plugin
module.exports =  {"container":"_0bc5e8de02--container--EU8SN","inner":"_0bc5e8de02--inner--ICVGh","title":"_0bc5e8de02--title--rU4qK","subtitle":"_0bc5e8de02--subtitle--xUIVH"};